import { fallback, http, WagmiProvider, webSocket } from "wagmi";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CHAIN, IS_MAINNET, setAppKit, setIsMiniApp } from "../utils/Constants";
import { ReactNode, useEffect, useState } from "react";

import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { sdk } from "@farcaster/miniapp-sdk";
import { farcasterMiniApp as miniAppConnector } from "@farcaster/miniapp-wagmi-connector";
import { Attribution } from "ox/erc8021";

const queryClient = new QueryClient();

const wagmiAdapter = new WagmiAdapter({
  networks: [CHAIN],
  transports: {
    [CHAIN.id]: fallback([
      webSocket(import.meta.env.VITE_RPC_WEBSOCKET_URL),
      http(import.meta.env.VITE_RPC_HTTP_URL),
    ]),
  },
  projectId: import.meta.env.VITE_REOWN_PROJECT_ID,
  connectors: [miniAppConnector()],
  dataSuffix: Attribution.toDataSuffix({
    codes: ["bc_wcjlvtjd"],
  }),
});

export function BlockchainProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      const isMiniApp = await sdk.isInMiniApp();
      if (isMiniApp) {
        setIsMiniApp(true);
        await sdk.actions.ready();
        // try {
        //   await sdk.actions.addMiniApp();
        // } catch (e) {
        //   console.error(e);
        // }
      } else {
        const appKit = createAppKit({
          debug: !IS_MAINNET,
          networks: [CHAIN],
          adapters: [wagmiAdapter],
          projectId: import.meta.env.VITE_REOWN_PROJECT_ID,
          metadata: {
            name: "BitMillions",
            description: "Play for the prize, stay for the cause.",
            url: `${window.location.origin}`,
            icons: [`${window.location.origin}/logo.png`],
          },
          enableNetworkSwitch: false,
          themeVariables: {
            "--apkt-font-family": "Poppins",
            "--apkt-accent": "#A5477B",
            "--apkt-color-mix": "#0e0d13",
            "--apkt-border-radius-master": "1px",
          },
        });

        setAppKit(appKit);
      }
      setReady(true);
    })();
  }, []);

  if (!ready) return null;

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
